export default "__VITE_ASSET__DRK3zV7g__"